import axios from 'axios';
import {API} from "@/services/url";


export default {
	getCustomerList: function (success,error) {
		axios.get(API.customer.all)
			.then(r => success(r.data.officeList) )
			.catch(e => error(e.response.data.message));
	},
	// updateCustomer: function (officeId, form, success, error) {
	// 	axios.post(API.customer.updateCustomer+officeId, form, {
	// 		headers : {"Content-Type": "multipart/form-data"}
	// 	})
	// 		.then( r => success(r.data.officeList) )
	// 		.catch( e => error(e.response.data.message));
	// },
	updateCustomer: function (officeId, request, success, error) {
		axios.post(API.customer.updateCustomer+officeId, request)
			.then( r => success(r.data.officeList) )
			.catch( e => error(e.response.data.message));
	},
	updateApiAccess: function (request,success,error) {
		axios.post(API.customer.updateApiAccess+request.id,request)
			.then(r => success(r.data.office))
			.catch(e => error(e.response.data.message))
	},
	generateNewToken: function(id,success,error) {
		axios.post(API.customer.generateApiToken+id)
			.then(r => success(r.data.office))
			.catch( e => error(e.response.data.message))
	},
	mailApiToken: function (data,success,error) {
		axios.post(API.customer.mailApiToken + data.id,data)
			.then(r => success(r))
			.catch( e => error(e.response.data.message))
	},
	getProjectNames: function (success,error) {
		axios.get(API.customer.projectNames)
			.then(r => success(r.data.projectNames) )
			.catch(e => error(e.response.data.message));
	},
	createNewProject : function (data, success, error) {
		axios.post(API.customer.createProject, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getProjectDeviceList: function (projectId, success,error) {
		axios.get(API.customer.projectDeviceList + projectId)
			.then(r => success(r.data.deviceList) )
			.catch(e => error(e.response.data.message));
	},
	assignAnEmployeeToSupport : function (data, success, error) {
		axios.post(API.customer.assignSupportEmployee, data)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
	getAvailableSupportEmployees : function (success,error) {
		axios.get(API.customer.getAvailableSupportEmployees)
			.then(r => success(r.data.employeeList) )
			.catch(e => error(e.response.data.message));
	},
	getAllCustomerSupportDetails : function (success,error) {
		axios.get(API.customer.getAllCustomerSupportDetails)
			.then(r => success(r.data.customerSupportDetails))
			.catch(e => error(e.response.data.message));
	}

}
